export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14187.cd6174e2.jpg";